module.exports = __webpack_public_path__ + "static/media/Group 2324.d8ba8a34.svg";